import ApisShow from "../components/apis/Show";

export default [
  { name: 'Apis', path: '/apis', component: ApisShow,  }
]
